export type AssignableVolunteer = {
  volunteer_id: string;
  fullName: string;
  department: string | null;
  departmentsList: string[];
};

export function volunteerInDepartment(vol: AssignableVolunteer, deptName: string): boolean {
  const key = deptName.trim().toLowerCase();
  if (!key) return false;
  return vol.departmentsList.includes(key);
}

export function filterVolunteersForAssignment(
  volunteers: AssignableVolunteer[],
  activeDepartment: string | null,
  searchQuery: string
): AssignableVolunteer[] {
  let list = volunteers;

  if (activeDepartment) {
    list = list.filter((vol) => volunteerInDepartment(vol, activeDepartment));
  }

  const q = searchQuery.trim().toLowerCase();
  if (!q) return list;

  return list.filter((vol) => {
    const nameMatch = vol.fullName.toLowerCase().includes(q);
    const deptMatch = vol.department ? vol.department.toLowerCase().includes(q) : false;
    return nameMatch || deptMatch;
  });
}

export function inferActiveDepartmentForEdit(
  assignedDepartments: string[],
  assignedVolunteerIds: string[],
  volunteers: AssignableVolunteer[],
  departmentNames: string[]
): string | null {
  const firstDept = assignedDepartments.find((d) => d.trim().length > 0);
  if (firstDept) return firstDept;

  const firstVolunteerId = assignedVolunteerIds.find(Boolean);
  if (!firstVolunteerId) return null;

  const volunteer = volunteers.find((v) => v.volunteer_id === firstVolunteerId);
  if (!volunteer?.departmentsList.length) return null;

  const volunteerDeptKeys = new Set(volunteer.departmentsList);
  return departmentNames.find((name) => volunteerDeptKeys.has(name.trim().toLowerCase())) ?? null;
}
